import PropTypes from 'prop-types';
import React from 'react';
import Dialog from 'components/Molecules/Dialog';
import Typographys from 'components/Atoms/Typography';

const DeleteQuery = ({ handleCancel, primaryBtn, secondaryBtn, queryTitle, open, handleClose, handleDelete }) => {
  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      dialogTitle="Delete Query"
      dialogDesc={
        <Typographys variant="body2" color="neutral.600" align="center">
          Are you sure you want to delete the query -
          <Typographys color="neutral.800" sx={{ display: 'inline', pl: 1 }}>
            {queryTitle}
          </Typographys>
          ?
        </Typographys>
      }
      handlePrimaryBtn={handleDelete}
      primaryBtnColor="error"
      primaryBtn={primaryBtn}
      secondaryBtn={secondaryBtn}
      handleSecondaryBtn={handleCancel}
      bodyContent={false}
    />
  );
};
DeleteQuery.defaultProps = {
  handleDelete: () => {},
  queryTitle: '',
  primaryBtn: 'Delete',
  secondaryBtn: 'Cancel',
  handleCancel: () => {},
  open: true,
  handleClose: () => {},
};
DeleteQuery.propTypes = {
  queryTitle: PropTypes.string,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleDelete: PropTypes.func,
  handleCancel: PropTypes.func,
  primaryBtn: PropTypes.string,
  secondaryBtn: PropTypes.string,
};
export default DeleteQuery;
